export const PAY_CONTRACT = {
  TITLE: "دفع معاملة",
  NO_PAYMENT_METHOD_TITLE: "لا توجد وسيلة دفع",
  NO_PAYMENT_METHOD_SUB_TITLE:
    "قم يإضافة وسيلة دفع للتمكن من دفع او استلام الأموال من خلال وفي",
  PAYMENT_METHODS: "وسائل الدفع",
  MADA_METHOD: "بطاقة مدى البنكية",
  VISA_METHOD: "بطاقة خصم مباشر/ائتمان",
  ADD: "إضافة",
  ENTER_PIN: "قم بإدخال رمز الأمان",
  AMOUNT_RESERVED: "سيتم حجز المبلغ في وفّي في حالة التأكيد",
  TRANSACTION_ACCEPTED: "تم قبول المعاملة والدفع بنجاح",
  VALUE_PAID: "تم دفع قيمة المعاملة. الاموال لدينا حاليا سوف نقوم اخطار البائع",
  TRANSACTION_FAILED: "عذراً، لم يتم دفع المعاملة",
  SOMETHING_WENT_WRONG: "حدث خطأ ما. برجاء إعادة محاولة الدفع مرة اخري",
  STEP_1:
    "اﻟﻤﺒﻠﻎ ﻟﺪﻳﻨﺎ اﻟﺎن وﻟﻦ ﻳﺘﻢ ارﺳﺎﻟﻪ ﻟﻠﺒﺎﺋﻊ اﻟﺎ ﺑﻌﺪ ﻣﺪة ﻓﺤﺼﻚ ﻟﻠﻤﻨﺘﺞ واﻟﻤﻮاﻓﻘﺔ ﻋﻠﻴﻪ",
  STEP_2:
    "ﺳﻮف ﻳﻘﻮم اﻟﺒﺎﺋﻊ ﺑﺎرﺳﺎل اﻟﻤﻨﺘﺞ اﻟﻴﻚ ﻟﺒﺪأ ﻓﺘﺮة ﻓﺤﺺ اﻟﻤﻨﺘﺞ واﻟﺘﺄﻛﺪ ﻣﻦ ﺟﻮدة",
  STEP_3:
    "في حالة حدوث اي خطأ او عدم استلام المنتج كما هو متفق عليه، يمكنك  التصعيد لوفّي",
};

export const CARD_DETAILS = {
  TITLE: "أدخل بيانات البطاقة",
  SUB_TITLE: "جميع بياناتك في امان وسرية تامة ولن نحتفظ باي معلومات",
  CARD_NUMBER: "رقم البطاقة",
  EXPIRY_DATE: "تاريخ الانتهاء",
  CVV: "رمز التحقق CVV",
  ADD_SAVE: "إضافة و حفظ",
  CARD_HOLDER_IMP: "اسم حامل البطاقة غير صحيح",
};

export const BUTTON = {
  ADDITION: "إضافة",
  EMPHASIS: "تأكيد",
  CLOSE: "إغلاق",
  TRY_AGAIN: "المحاولة مرة أخرى",
};
